import { render } from "./topmedia.vue?vue&type=template&id=1e873b37&ts=true"
import script from "./topmedia.vue?vue&type=script&lang=ts"
export * from "./topmedia.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kuradmin/dev-frontend-siputra/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__